import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const nycHudsonYardsOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'new-york',
  neighborhoodSlug: 'hudson-yards',
  neighborhoodDisplayName: 'Hudson Yards',
  metroDisplayName: 'New York',
  totalCodiClientsInNeighborhood: 1,
  nycLocalPreset: 'manhattanStandard',
  whereFromStreetsToLandmark: 'from the buildings along 10th Ave, 30th St, and 33rd St to the clusters near The Shed',
  whereTeamStreets: '10th Ave, 11th Ave, 30th St, 33rd St',
  clientDescriptor: 'a small team tech startup near 10th Ave',
  counts: {
    managedCleaningOffices: 1,
    managedPantryOffices: 1,
    managedInternetOffices: 1,
    managedFurnitureOffices: 1,
    managedOfficeAssistantOffices: 1,
    managedDeepCleaningOffices: 1,
    managedCarpetCleaningOffices: 1,
    managedWindowCleaningOffices: 1,
    managedGlassCleaningOffices: 1,
    managedWasteRecyclingOffices: 1,
    managedPantryInventoryOffices: 1,
    managedCoffeeServiceOffices: 1,
    managedWaterServiceOffices: 1,
    managedTeamLunchOffices: 1,
    managedBreakfastCateringOffices: 1,
    managedIndividualMealsOffices: 1,
    managedAdHocCateringOffices: 1,
    managedHappyHourOffices: 1,
    managedConferenceRoomAvOffices: 1,
    managedNetworkInstallationOffices: 1,
    managedNetworkManagementOffices: 1,
    managedCableManagementOffices: 1,
    managedRoomBookingOffices: 1,
    managedPrintingSetupOffices: 1,
    managedInteriorDesignOffices: 1,
    managedOfficeMuralsOffices: 1,
    managedOfficePaintingOffices: 1,
    managedGlassFrostingOffices: 1,
    managedOfficeSignageOffices: 1,
    managedCareRoomOffices: 1,
    managedFurnitureAssemblyOffices: 1,
    managedLayoutChangeOffices: 1,
    managedOfficePlantsOffices: 1,
    managedKeylessAccessOffices: 1,
    managedAlarmSystemsOffices: 1,
    managedSecurityCamerasOffices: 1,
    managedKeypadOffices: 1,
    managedLockboxOffices: 1,
    managedVisitorManagementOffices: 1,
    managedBusinessInsuranceOffices: 1,
    managedElectricalServicesOffices: 1,
    managedHvacOffices: 1,
    managedPlumbingOffices: 1,
    managedPestControlOffices: 1,
    managedOfficeMovingOffices: 1,
    managedMountingInstallationOffices: 2
  },
  quotes: {
    cleaning: "We didn't want to deal with elevator bookings and vendor coordination. Codi does it.",
    pantryRestocking: "Manhattan delivery windows are brutal. Codi figures it out so we don't have to.",
    internet: "Codi coordinated everything with the building ops team so we didn't have to.",
    officeAssistant: "Codi's on-site person handles packages, visitors, and vendor access \u2014 all of it.",
    officeFurniture:
      'Freight elevator booking for furniture deliveries is such a pain in these office buildings. Codi handled it end-to-end.',
    deepCleaning: 'Hudson Yards buildings have strict vendor access rules. Codi managed the whole coordination.',
    carpetCleaning: 'New development, high-end finishes \u2014 carpet care matters here. Codi handles the schedule.',
    windowCleaning: 'Floor-to-ceiling windows are a defining feature. Codi keeps them clean year-round.',
    glassConferenceRoom: 'All-glass conference rooms look stunning when maintained. Codi owns that maintenance.',
    wasteRecycling: 'NYC building regs for waste are strict. Codi keeps us compliant without the overhead.',
    pantryInventory:
      'Hudson Yards office, high standards \u2014 pantry stockouts are not acceptable. Codi prevents them.',
    coffeeService: 'Premium coffee setup is table stakes here. Codi manages equipment, beans, and maintenance.',
    waterService: 'Filtered water dispenser in a Hudson Yards office. Codi set it up and keeps it running.',
    teamLunch: 'Team lunch on the Hudson Yards terrace. Codi handles caterer selection and delivery logistics.',
    breakfastCatering:
      'Morning breakfast for the Hudson Yards team. Codi coordinates with building management for access.',
    individualMeals: 'Daily individual lunch program. Codi manages the vendor, delivery, and distribution.',
    adHocCatering: 'Investor visits to Hudson Yards need impeccable catering. Codi delivers every time.',
    happyHour: 'Hudson Yards happy hour with a view. Codi handles drinks and setup so the team can just enjoy it.',
    conferenceRoomAv:
      'Hudson Yards demands premium A/V in every conference room. Codi sourced and installed the full setup.',
    networkInstallation:
      'New-build Hudson Yards office, needed a network built to spec. Codi designed and installed everything.',
    networkManagement:
      'Codi manages our Hudson Yards network proactively. We haven\u2019t had a service disruption since day one.',
    cableManagement:
      'Hudson Yards building standards are strict. Codi managed every cable run to meet building requirements.',
    roomBooking:
      'High-usage conference rooms in Hudson Yards needed a smart booking system. Codi deployed and manages it.',
    printingSetup:
      'Codi handled our Hudson Yards printer installation \u2014 freight elevator booking, install, and full driver rollout.',
    interiorDesign:
      'Premium Hudson Yards space needed a design befitting the address. Codi managed the full design and fit-out process.',
    officeMurals:
      'Brand mural in a Hudson Yards office is a statement. Codi sourced the right artist and handled building approval.',
    officePainting:
      'Pre-occupancy painting in our Hudson Yards space. Codi coordinated with building management for after-hours access.',
    glassFrosting:
      'Executive suite glass frosting for privacy in an open tower floor. Codi installed it cleanly in a single visit.',
    officeSignage:
      'Hudson Yards building standards require precise signage installation. Codi handled all permitting and mounting coordination.',
    careRoom:
      'New-build office with no designated private room. Codi furnished and set up a proper care room from scratch.',
    furnitureAssembly:
      'Full fit-out assembly for our Hudson Yards floor. Codi coordinated freight elevator access and assembly teams.',
    layoutChange:
      'Executive floor restack in Hudson Yards. Codi moved furniture and managed all cable rerouting over one weekend.',
    officePlants:
      'Hudson Yards floor-to-ceiling windows are ideal for plants. Codi designed and manages a premium plant program.',
    keylessAccess:
      'Hudson Yards building security required full keyless access compliance before move-in. Codi handled vendor selection, installation, and credential provisioning.',
    alarmSystems:
      'Premium building required a monitored alarm with specific vendor approvals. Codi managed the full compliance and installation process.',
    securityCameras:
      'High-end Hudson Yards office needed camera coverage at all access points. Codi installed a system that meets building standards.',
    keypads:
      'Multiple access points in our Hudson Yards space. Codi installed keypads and manages all credential assignments.',
    lockboxes:
      'Vendor access in Hudson Yards requires building management coordination. Codi manages the lockbox and handles all building communication.',
    visitorManagement:
      'Hudson Yards offices get executive and investor traffic. Codi deployed a premium visitor management system with full compliance logging.',
    businessInsurance:
      'Hudson Yards lease has strict COI requirements. Codi manages our business insurance and ensures certificates are always current.',
    electricalServices:
      'New-build Hudson Yards office required electrical customization for executive infrastructure. Codi managed the licensed master electrician and all DOB permit coordination.',
    hvac: 'Premium Hudson Yards building with complex shared HVAC systems. Codi manages our licensed HVAC vendor and coordinates with building engineering for all service work.',
    plumbing:
      'Hudson Yards building standards require licensed plumbers with specific COI. Codi manages vendor vetting and all building notification for plumbing work.',
    pestControl:
      'Hudson Yards building management requires documented pest control compliance. Codi schedules and manages all quarterly treatments.',
    officeMoving:
      'Moving into a Hudson Yards tower requires precise coordination with building management. Codi managed the full move \u2014 mover selection, freight access, and setup.',
    mountingInstallation:
      'Premium Hudson Yards finishes required specialist mounting vendors. Codi managed installation to meet building standards across all conference rooms.'
  },
  officeAssistant: {},
  metroWideDemandPullquote: 'all'
});
